import { Status } from './status';

export class SmsModel {
  id:number;
  phoneNumber:string;
  message:string;
  pinCount:number;
  createdTime:Date;
  lastUpdatedTime:Date;
  lastUpdatedUser:string;
  status:Status;

  constructor(id:number,status:Status) {
    this.id=id;
    this.status=status;
  }


}
